(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ska-spotlight"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ska-spotlight')) {
    customElements.define('ska-spotlight', class extends HTMLElement {
      connectedCallback() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.section = this.closest('.shopify-section') || this.parentElement;
        this.cards = this.findCards();
        if (this.cards.length < 2) return;
        const accent = this.style.getPropertyValue('--ska-spot');
        this.cards.forEach((c) => { c.classList.add('ska-spot-card'); c.style.setProperty('--ska-spot', accent); });

        this.onScroll = () => this.update();
        // Only a real mouse lights cards; a tap on a touch screen also fires
        // pointerenter and must not override the scroll light.
        this.onEnter = (e) => { if (!this.scrolling && e.pointerType === 'mouse') this.light(this.cards.indexOf(e.currentTarget)); };
        this.onLeave = (e) => { if (!this.scrolling && e.pointerType === 'mouse') this.light(-1); };
        this.cards.forEach((c) => {
          c.addEventListener('pointerenter', this.onEnter);
          c.addEventListener('pointerleave', this.onLeave);
        });
        // A mouse or trackpad (desktop) follows the pointer; touch screens
        // follow the scroll. Re-check if that changes (a tablet with a mouse).
        this.mouse = window.matchMedia('(hover: hover) and (pointer: fine)');
        this.onMode = () => this.setMode();
        this.mouse.addEventListener('change', this.onMode);
        this.setMode();
      }
      disconnectedCallback() {
        if (!this.onScroll) return;
        this.stopScroll();
        this.mouse.removeEventListener('change', this.onMode);
        this.cards.forEach((c) => {
          c.removeEventListener('pointerenter', this.onEnter);
          c.removeEventListener('pointerleave', this.onLeave);
          c.classList.remove('ska-spot-card', 'is-lit', 'is-shaded');
        });
      }
      setMode() {
        this.stopScroll();
        if (this.mouse.matches) {
          this.light(-1);
        } else {
          // Capture scroll events from any element: on wide screens Horizon
          // scrolls .page-wrapper, not the window.
          document.addEventListener('scroll', this.onScroll, { passive: true, capture: true });
          window.addEventListener('resize', this.onScroll);
          this.scrolling = true;
          this.update();
        }
      }
      stopScroll() {
        if (!this.scrolling) return;
        document.removeEventListener('scroll', this.onScroll, { capture: true });
        window.removeEventListener('resize', this.onScroll);
        this.scrolling = false;
      }
      // The cards are the children of the first group in this section that
      // holds two or more groups side by side (or stacked on phones).
      findCards() {
        for (const inner of this.section.querySelectorAll('.group-block-content')) {
          const kids = [...inner.children].filter((k) => k.classList.contains('group-block'));
          if (kids.length >= 2) return kids;
        }
        return [];
      }
      // Light one card and shade the rest; -1 leaves every card as normal.
      light(lit) {
        this.cards.forEach((c, i) => {
          c.classList.toggle('is-lit', i === lit);
          c.classList.toggle('is-shaded', lit !== -1 && i !== lit);
        });
      }
      // Touch screens: the card nearest the middle of the screen. If the
      // cards sit in a row (a tablet held sideways), the light moves left to
      // right while the row crosses the screen.
      update() {
        const h = window.innerHeight;
        const boxes = this.cards.map((c) => c.getBoundingClientRect());
        let lit = 0;
        // Layout positions (offsetTop), not screen boxes: the shaded cards
        // are scaled down, which would make a row look uneven.
        if (this.cards.every((c) => Math.abs(c.offsetTop - this.cards[0].offsetTop) < 2)) {
          const p = Math.min(0.999, Math.max(0, (h * 0.9 - boxes[0].top) / Math.max(1, h * 0.75)));
          lit = Math.floor(p * this.cards.length);
        } else {
          let best = Infinity;
          boxes.forEach((b, i) => {
            const d = Math.abs(b.top + b.height / 2 - h / 2);
            if (d < best) { best = d; lit = i; }
          });
        }
        this.light(lit);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
